if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
        function getCookie(name) {
          const match = document.cookie.match(
            new RegExp("(^| )" + name + "=([^;]+)")
          );
          return match ? decodeURIComponent(match[2]) : null;
        }
        setTimeout(function () {
          $.getJSON("/cart.js").done(function (cart) {
         var hasSubscription = false;
         cart.items.forEach(function (item) {
      
         if (item.selling_plan_allocation) {
          hasSubscription = true;
          
        }
         });
          if (hasSubscription) {
        
        $('a.button.custom_checkout-button').hide();
        $("button#CartDrawer-Checkout").show();
      } else {
       
        $('a.button.custom_checkout-button').css('display', 'inline-flex');
        $("button#CartDrawer-Checkout").hide();
      }
       if (cart.attributes && cart.attributes.selected_pack) {
    var selectedPack = cart.attributes.selected_pack;
    console.log('Selected Pack:', selectedPack);
    $('.subscription-box-item .subscription-box-title').text(selectedPack)
  }
      let boxTitle = $('.subscription-box-header .subscription-box-title').text().trim().toLowerCase(); // small / large
let maxLimit = 0;

if (boxTitle.includes('signature') || boxTitle.includes('small')) {
  maxLimit = 7;
  // Hide the large box error
  $('.checkout--error-msg-new').hide();
} else if (boxTitle.includes('large')) {
  maxLimit = 11;
  // Hide the small box error
  $('.checkout--error-msg').hide();
}

let current = cart.item_count;

// Select proper error message container based on box type
let errorContainer = maxLimit === 7 ? $('.checkout--error-msg') : $('.checkout--error-msg-new');

// Logic for cart item limits
if (current > maxLimit) {
  let extra = current - maxLimit;
  $('button.cart__checkout-button.button').attr('disabled', 'disabled');
  $('a.button.custom_checkout-button').attr('disabled', 'disabled');
  errorContainer.find('.extra-items-1').text(extra);
  errorContainer.text(`Please remove ${extra} item(s).`).show();

} else if (current < maxLimit) {
  let remaining = maxLimit - current;
  $('button.cart__checkout-button.button').removeAttr('disabled');
  $('a.button.custom_checkout-button').removeAttr('disabled');
  errorContainer.find('.extra-items-1').text(remaining);
  errorContainer.text(`Add ${remaining} more item(s) to ${boxTitle.charAt(0).toUpperCase() + boxTitle.slice(1)} Box.`).show();
} else {
  // exactly at limit
  $('button.cart__checkout-button.button').removeAttr('disabled');
  $('a.button.custom_checkout-button').removeAttr('disabled');
  errorContainer.hide();
}
      
    });
          const freeOfferVariantId = parseInt(getCookie("selected_variant_id"));

           $.getJSON("/cart.js").done(function (cart) {
            let totalCount = 0;
            let cartTotal = 0;

            cart.items.forEach(function (item) {
              if (item.variant_id === freeOfferVariantId) {
                return;
              }

              totalCount += item.quantity;
              cartTotal += (item.price * item.quantity);
            });
            
            // Convert cartTotal from cents to dollars
            cartTotal = cartTotal / 100;
            
if ($('body').hasClass('product')) {
            // Enable checkout once at least 6 items are in the cart (free gift excluded from totalCount above)
            if (totalCount >= 6) {
              $("button#CartDrawer-Checkout").removeAttr(
                "disabled",
                "disabled"
              );
               $('.cart-error-message-five-qty').hide();
            } else {
              $("button#CartDrawer-Checkout").attr("disabled", "disabled");
               $('.cart-error-message-five-qty').show();
            }
          }
          });
          var getQtypdp = parseInt($('product-info quantity-input.quantity .quantity__input').val());
    console.log(getQtypdp)
    if (getQtypdp >= 5) {
        $('product-info .shopify-payment-button').show();
    }else{

 $('product-info .shopify-payment-button').hide();
    }
        }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
